import { Col, ListGroup, Modal, Row } from "react-bootstrap";

import { getUserRole, UserRole } from "../../utils/user";
import { useGlobalOptions } from "./GlobalOptionsContext";

export const AssumedRoleModal = (props: {
    showModal: boolean,
    setShowModal: any,
    user: any,
}) => {
    const { getDerivedRole, changeAssumedRole } = useGlobalOptions();

    const handleClose = () => {
        props.setShowModal(false);
    };

    if (getUserRole(props.user) !== UserRole.ADMIN) {
        return <></>
    }

    return (
        <Modal show={props.showModal} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Assume Role</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <ListGroup>
                            <ListGroup.Item action active={getDerivedRole(props.user) === UserRole.ADMIN} onClick={() => {changeAssumedRole(props.user, UserRole.ADMIN)}}>
                                Admin
                            </ListGroup.Item>
                            <ListGroup.Item action active={getDerivedRole(props.user) === UserRole.BETA} onClick={() => {changeAssumedRole(props.user, UserRole.BETA)}}>
                                Beta
                            </ListGroup.Item>
                            <ListGroup.Item action active={getDerivedRole(props.user) === UserRole.BASIC} onClick={() => {changeAssumedRole(props.user, UserRole.BASIC)}}>
                                Basic
                            </ListGroup.Item>
                        </ListGroup>
                    </Col>
                </Row>

            </Modal.Body>
        </Modal>
    );
};
